<template>
  <div class="cs-videoApp-studentButton-container">
    <el-button v-if="viewEnable && USERMANAGER.isStudent" type="primary" size="mini"
      @click="onView">查看详情</el-button>
    <el-button v-if="cancelEnable && USERMANAGER.isStudent" :disabled="btnDisabled" type="primary" size="mini"
      @click="onCancel">取消预约</el-button>
    <el-button v-if="editView" :disabled="btnDisabled" type="primary" size="mini" @click="onContinue">编辑预约</el-button>
    <el-button v-if="payEnable" :disabled="btnDisabled" type="primary" size="mini" @click="onPay">付 款</el-button>
  </div>
</template>

<style lang="scss" scoped>
.cs-videoApp-studentButton-container {
  .el-button {
    display: block;
    margin-left: 0;

    &:not(:first-of-type) {
      margin-top: 5px;
    }
  }

}
</style>

<script>
import {
  cancelVideoAppointment,
} from "../../../service/videoAppointment.service";
import global_ from "../../../core/global";

export default {
  props: {
    data: {},
    columnData: {},
    status: {}
  },
  data() {
    return {
      btnDisabled: false,
      cancelEnable: false,
      editView: false,
      continueEnable: false,
      payEnable: false,
      viewEnable: false
    };
  },
  components: {},
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!!this.data) {
        this.cancelEnable = this.data.CancelEnable;
        this.continueEnable = this.data.ContinueEnable;
        this.editView = this.data.EditView;
        this.payEnable = this.data.PayEnable;
        this.viewEnable = this.data.ViewEnable;
      }
    },
    onCancel() {
      let message = "是否要取消预约?";

      // if (this.data.BalanceCost > 0 || this.data.BonusPointPrice > 0) {
      //   message +=" 如在预约时间24小时前取消该预约，系统退还所有费用，如在预约时间24小时内取消该预约，系统仅退还50%费用，在预约时间3小时以内无法取消该预约。"
      // }
      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.btnDisabled = true;

          cancelVideoAppointment(this.data.Id)
            .then(result => {
              if (!!result && result.success) {
                this.$emit("reload");
              } else {
                this.$message.error(result.message);
              }

              this.btnDisabled = false;
            })
            .catch(err => {
              this.btnDisabled = false;
            });
        })
        .catch(() => { });
    },
    onContinue() {
      if (!this.continueEnable) {
        this.$message.error("在预约开始前6小时内不能编辑预约");
        return;
      }
      let data = {
        name: "continue",
        id: this.data.Id,
        //isCompleted: this.data.IsCompleted,
      };
      this.$emit("customEvent", data);
    },
    onPay() {
      let data = {
        name: "pay",
        id: this.data.Id
      };
      this.$emit("customEvent", data);
    },
    onView(){
      let data = {
        name: "view",
        id: this.data.Id
      };
      this.$emit("customEvent", data);
    }
  },
  watch: {
    data: function () {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/studentVideoButtonCell.vue